"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Stepper = _interopRequireDefault(require("./Stepper.theme"));

var S = _interopRequireWildcard(require("./styles"));

var _excluded = ["steps", "current", "theme"];

var Stepper = function Stepper(_ref) {
  var steps = _ref.steps,
      current = _ref.current,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var sizeStepper = 100 / steps;
  var barWidth = sizeStepper * current;
  var stepperTheme = (0, _Stepper.default)(theme.colors.neutral100, theme.colors.primary);
  return /*#__PURE__*/_react.default.createElement(S.Container, Object.assign({
    appearance: stepperTheme.stepper
  }, rest), /*#__PURE__*/_react.default.createElement(S.StepContainer, {
    appearance: stepperTheme.progressStepper,
    barWidth: barWidth
  }));
};

Stepper.defaultProps = {
  steps: 1,
  current: 0
};

var _default = (0, _styledComponents.withTheme)(Stepper);

exports.default = _default;